import React, { useEffect, useState, forwardRef } from 'react'
import styled from 'styled-components'
import media from 'styled-media-query'
import Modal from '../../organisms/CenterCards/Modal'
import Button from '../../atoms/Button/Button'
import phonePurple from '../../../images/icon-phone-purple.svg'
import whiteEnvelope from '../../../images/icon-envelope-white.svg'
import iconPhoneWhite from '../../../images/icon-phone-white.svg'
import iconWeb from '../../../images/icon-web-purple.svg'
import iconWebGray from '../../../images/icon-web-gray-50.svg'
import iconEnvelopePurple from '../../../images/icon-envelope-purple.svg'
import unclaimedIcon from '../../../images/Icon_Unclaimed.svg'
import womenIcon from '../../../images/Icon_Men-Only copy.svg'
import budgetIcon from '../../../images/Icon_Budget-Friendly.svg'
import counselingIcon from '../../../images/Icon_1-on-1-Counseling.svg'
import culturalIcon from '../../../images/Icon_Cultural-Experiences.svg'
import locationIcon from '../../../images/Icon_Therapeutic-Location.svg'
import proIcon from '../../../images/Icon_Certified-Professionals.svg'
import lakeIcon from '../../../images/Icon_Lakeside.svg'
import menIcon from '../../../images/Icon_Men-Only.svg'
import brainIcon from '../../../images/Icon_Co-Occurring-Disorders-Treatment.svg'
import oneIcon from '../../../images/Icon_One-Icon.svg'
import holisticIcon from '../../../images/Icon_Holistic-Approach.svg'
import equineIcon from '../../../images/Icon_Equine-Therapy.svg'
import techIcon from '../../../images/Icon_Tech-Friendly.svg'
import treeIcon from '../../../images/Icon_Acre-Grounds.svg'
import spaIcon from '../../../images/Icon_On-Site-Spa.svg'
import functionIcon from '../../../images/Icon_Functional-Medicine-Approach.svg'
import bellIcon from '../../../images/Icon_Concierge-Approach.svg'
import beachIcon from '../../../images/Icon_Beach-Access.svg'
import appleIcon from '../../../images/Icon_Eating-Disorder.svg'
import ibogaineIcon from '../../../images/Icon_Ibogaine-Treatment.svg'
import badgeIcon from '../../../images/Icon_Accredited.svg'
import detoxIcon from '../../../images/Icon_Onsite-Detox.svg'
import masterIcon from '../../../images/Icon_Therapist-Master-Level.svg'
import musicIcon from '../../../images/icon-music.svg'
import recoveryIcon from '../../../images/icon-recovery.svg'
import detachedHouseIcon from '../../../images/icon-detached-house.svg'
import executiveIcon from '../../../images/icon-executive.svg'
import cabinIcon from '../../../images/icon-cabin.svg'
import clockIcon from '../../../images/icon-clock.svg'
import privateRoomIcon from '../../../images/Icon_Private-Rooms-Only.svg'
import insuranceIcon from '../../../images/Icon_Insurance-Accepted.svg'
import boutiqueIcon from '../../../images/Icon_Boutique.svg'
import languageIcon from '../../../images/Icon_Language.svg'
import nonProfitIcon from '../../../images/Icon_Non-Profit.svg'
import yearsIcon from '../../../images/Icon_Years-In-Business.svg'
import familyIcon from '../../../images/Icon_Family-Owned.svg'
import clipboardIcon from '../../../images/Icon_Customized-Treatment-Plans.svg'
import poolIcon from '../../../images/Icon_Pool.svg'
import uhnwiIcon from '../../../images/Icon_UHNWI.svg'
import petFriendlyIcon from '../../../images/Pet_Friendly.svg'
import useInsights from '../../../hooks/algolia/useInsights'
import Tooltip from '../../molecules/Tooltip'
import Sliders from '../../organisms/Slider/Slider'
import NavMarkers from '../StickyBar/NavMarkers'
import { removeWhiteSpaces } from '../../../utils/replaceWith'
import { ChevronRight } from 'react-bootstrap-icons'
import { createDataLayerIfNotExists } from '../../../utils/global/createDataLayerIfNotExists'
import centerHasNoPricing from '../../../domain/center/useCases/centerHasNoPricing'
import CenterStatusBadge from '../CenterStatusBadge/CenterStatusBadge'
import {
  hasWebsite,
  getWebsite,
  isFreeListing,
  getLogo,
  getPhoneNumbers,
  getCenterProfileSlug
} from '../../../domain/center.js'
import { shouldShowCenterHighlights } from '../../../domain/center/shouldShowCenterHighlights'
import { isNonEmptyArray, isNonEmptyString } from '../../../utils/checks'
import useSegment from '../../../hooks/segment/useSegment'
import CenterBadgesAndRatingSection from '../CenterCards/CenterBadgesAndRatingSection'
import {
  updateFavoriteStorage,
  isFavorite
} from '@/domain/favoriteCenters/updateFavoriteStorage'
import FavoriteCenterHeartButtonContactBlock from '@/components/favorite/FavoriteCenterHeartButtonContactBlock/FavoriteCenterHeartButtonContactBlock'
import { parseCenterId } from '../../../domain/center/useCases/parseCenterId'

const SliderColumn = styled.div`
  margin: 0 auto;
  max-width: 1400px;

  ${(props) =>
    (props.template === 'Standard' || props.template === null) &&
    media.lessThan('large')`
      padding: 0 5%;
    `}
  & > div {
    margin: 0;
  }
`

const Desktop = styled.div`
  padding-top: 110px;
  margin-top: -110px;
  display: none;
  ${media.greaterThan('medium')`
display: block;`}
`

const Style = styled.div`
  .badge {
    transform: translateY(-3px);
    ${media.lessThan('medium')`
    transform: translateY(-4px);
  `}
  }
  .calendar {
    font-size: 16px;
    ${media.lessThan('medium')`

  font-size: 12px !important;
  `}
  }
  max-width: 100vw;
  .mobile {
    display: none;
    ${media.lessThan('medium')`
  display: block;
  `}
  }
  .header-text {
    line-height: 54px;
    ${media.greaterThan('medium')`
    line-height: 40px;
  `}
  }
  max-width: 1200px;
  margin: 10px auto 0 auto;
  ${media.greaterThan('medium')`
  margin: 0px auto 0 auto;
`}
  margin: 30px auto 0 auto;
  display: flex;
  ${media.lessThan('medium')`
  flex-wrap: wrap;
  margin:16px;

  `}

  .message-box {
    width: 100%;
    min-height: 200px;
    border: 1px solid #e1e7ef;
    border-radius: 16px;
    background: #ffffff;
    padding: 40px 40px;
    img {
      vertical-align: text-top;
    }

    button {
      width: 100%;
      background: #222263;
      border-radius: 12px;
      font-weight: bold;
      &.claim {
        background: 'purple';
      }
    }
  }
  .contact-box {
    margin-top: 16px;
    width: 100%;
    padding: 30px;
    border: 1px solid #e4e4e4;
    ${media.lessThan('medium')`
    width: 97%;
    margin: 0 auto;
    padding: 30px;
    margin-top: 16px;

    `}
    li {
      margin-top: 10px;
    }
    img {
      width: 20px;
      display: inline-block;
      vertical-align: text-top;
      margin-right: 10px;
    }
    .logo {
      width: 200px;
      margin: 0 auto;
      display: block;
    }
  }
  .highlight-icon {
    filter: invert(0%) sepia(0%) saturate(2) hue-rotate(233deg) brightness(25%)
      contrast(75%) !important;
  }
`
const whatsappRegex = /whatsapp/i

const shouldUseWhatsappText = (label) => whatsappRegex.test(label)

const CONTACT_CLASSNAME =
  'mt-4 bg-[#ebeaf4] rounded-md w-full px-4 py-[10px] flex justify-between items-center font-normal text-lg no-underline text-primary-800 w-full h-14'

export const getHighlightsWithIcons = (highlights) => {
  return highlights.map((item) => {
    const highlight = {
      label: item
    }

    const icons = {
      'Custom Built Facility': privateRoomIcon,
      'Customized Treatment Plans': clipboardIcon,
      'Doctor Level Therapists': masterIcon,
      'Billing Transparency': clipboardIcon,
      'Private Rooms Only': privateRoomIcon,
      'Private Rooms Available': privateRoomIcon,
      'Insurance Accepted': insuranceIcon,
      'Family Owned & Operated': familyIcon,
      'Bespoke With Exclusive Staff': familyIcon,
      'Concierge Approach': bellIcon,
      'Equine Therapy': equineIcon,
      'ALL Services On-Site': equineIcon,
      'Holistic Approach': holisticIcon,
      'Wellness Emphasis': holisticIcon,
      'Spiritual Emphasis': holisticIcon,
      'Co-Occurring Disorders Treatment': brainIcon,
      '1-on-1 Sessions Only': counselingIcon,
      'Unlimited 1-on-1 Counseling Sessions': counselingIcon,
      'World Renowned Team of Experts': counselingIcon,
      '4+ Individual Sessions a Week': counselingIcon,
      'Daily Individual Therapy': counselingIcon,
      '1-on-1 Counseling': counselingIcon,
      Boutique: boutiqueIcon,
      'In-house Day Spa & Gym': spaIcon,
      'Non 12-Step Approach': holisticIcon,
      '12-Step Approach': holisticIcon,
      'One Client at a Time': oneIcon,
      'Certified Professionals': proIcon,
      'Dietary Accommodations': appleIcon,
      'On-site Spa': spaIcon,
      'Therapeutic Location': locationIcon,
      Nonprofit: nonProfitIcon,
      'Perfect for UHNWI': uhnwiIcon,
      'Created for UHNWI & Executives': uhnwiIcon,
      'Tech Friendly': techIcon,
      'Men Only': menIcon,
      'Perfect for Professionals': proIcon,
      Lakeside: lakeIcon,
      Pool: poolIcon,
      'Beach Access': beachIcon,
      'Tropical Location': beachIcon,
      'Budget Friendly': budgetIcon,
      'Women Only': womenIcon,
      'Eating Disorders Program': appleIcon,
      'Functional Medicine Approach': functionIcon,
      'Ibogaine Treatment': ibogaineIcon,
      'Joint Commission Accredited': badgeIcon,
      'CARF Accredited': badgeIcon,
      'Celebrating 15 Years of Service': badgeIcon,
      'On-site Medical Detox': detoxIcon,
      'Licensed Medical Facility': detoxIcon,
      'Medically Assisted Detox': detoxIcon,
      "Master's Level Therapists": masterIcon,
      'Doctorate Level One-On-One Therapy': masterIcon,
      "Master's and Doctoral Level Therapists": masterIcon,
      'Licensed for Both Addiction & Mental Health': masterIcon,
      'Unique Cultural Experiences': culturalIcon,
      'Recording Studio': culturalIcon,
      'Trauma-Informed Care': brainIcon,
      'Private Villa': boutiqueIcon,
      'Utmost Confidentiality': counselingIcon,
      'Neuro/Bio Feedback Therapy': counselingIcon,
      'Mental Health Disorder Treatment': counselingIcon,
      'Nature Lovers': treeIcon,
      'Wolf Therapy': petFriendlyIcon,
      'Pet Friendly': petFriendlyIcon,
      Accredited: badgeIcon,
      Adolescents: boutiqueIcon,
      'Personalized Treatment Plans': clipboardIcon,
      'On-site Psychiatric Care': counselingIcon,
      'Full-time Psychiatrist': masterIcon,
      'Onsite Recording Studio': musicIcon,
      '3 Hours of Daily Work Time': clockIcon,
      '20+ Hours of Individual Therapy': counselingIcon,
      'Private Beach': beachIcon,
      'Addiction Recovery': recoveryIcon,
      'Trauma Treatment': clipboardIcon,
      'Hospital-Based Detox': detoxIcon,
      'Gender Separate Housing': detachedHouseIcon,
      'Executive Treatment': executiveIcon,
      'Residential Cabins': cabinIcon,
      'Individual Therapy and Group Therapy': counselingIcon
    }
    if (!isNonEmptyString(item)) {
      return highlight
    }
    if (icons[item]) {
      highlight.icon = icons[item]
      return highlight
    }
    if (item.match(/years/i)) {
      highlight.icon = yearsIcon
    }
    if (item.includes('Acre')) {
      highlight.icon = treeIcon
    }
    if (item.includes('English')) {
      highlight.icon = languageIcon
    }
    if (item.match(/session.*week/i)) {
      highlight.icon = counselingIcon
    }
    return highlight
  })
}

const ProfileIntro = forwardRef(function ProfileIntro(
  {
    data: center,
    breadcrumbs,
    queryID = '',
    virtualTourElementId = '',
    pageType,
    allReviewsCount,
    allReviewsWeightedAverage
  },
  ref
) {
  const analytics = useSegment()

  const [modal, setModal] = useState(false)
  const { userID, recordAlgoliaConversion } = useInsights()
  const toggleModal = () => {
    setModal(!modal)
    if (document) {
      document.querySelector('html').style.overflow = modal ? null : 'hidden'
    }
  }

  // the below code pertains to Google Tag Manager and may have no context outside of this file; DO NOT DELETE.
  const handleDataLayerWebsiteClick = (center) => {
    createDataLayerIfNotExists()
    window.dataLayer.push({ ecommerce: null })
    window.dataLayer.push({
      event: 'add_to_cart',
      ecommerce: {
        items: [
          {
            item_name: center.title,
            item_id: center.slug,
            item_variant: center.listing_template,
            item_category: 'Profile Intro Outbound Website Click'
          }
        ]
      }
    })
  }

  // the below code pertains to Google Tag Manager and may have no context outside of this file; DO NOT DELETE.
  const handleDataLayerInquiryClick = (center) => {
    createDataLayerIfNotExists()
    window.dataLayer.push({ ecommerce: null })
    window.dataLayer.push({
      event: 'Inquiry click',
      ecommerce: {
        items: [
          {
            item_name: center.title,
            item_id: center.slug,
            item_variant: center.listing_template,
            item_category: 'Inquiry Form Modal Click'
          }
        ]
      }
    })
  }

  // the below code pertains to Google Tag Manager and may have no context outside of this file; DO NOT DELETE.
  const handleDataLayerPhoneNumberClick = ({ center, number, label }) => {
    analytics.ui.callCta({
      number,
      label,
      center_slug: getCenterProfileSlug(center)
    })
    recordAlgoliaConversion({
      userID,
      event: 'ProfileCall',
      queryID: queryID,
      objectID: center.slug
    })

    createDataLayerIfNotExists()
    window.dataLayer.push({ ecommerce: null })
    window.dataLayer.push({
      event: 'purchase',
      ecommerce: {
        items: [
          {
            item_name: center.title,
            item_id: center.slug,
            item_variant: center.listing_template,
            item_category: 'Profile Intro Phone Number'
          }
        ]
      }
    })
  }

  useEffect(() => {
    if (window.location.hash.includes('#message')) {
      window.scrollTo(0, 0)
      toggleModal()
    }
  }, [])

  const sliderProps = {
    basic: false,
    slides: center.slides,
    hideOnMobile: false,
    data: center,
    virtualTour: center?.virtual_tour_embed,
    virtualTourElementId
  }

  const showSubmitPrice = centerHasNoPricing(center) && isFreeListing(center)

  const centerLogo = getLogo(center)

  const [isFavoriteState, setIsFavoriteState] = useState(false)

  useEffect(() => {
    setIsFavoriteState(isFavorite(center.centerId))
  }, [center.centerId])

  return (
    <React.Fragment>
      {modal && (
        <Modal
          queryID={queryID}
          dashboard={center.analyticsDashboard || ''}
          busContact={center.businessContact}
          slug={center.slug}
          listing_template={center.listing_template}
          email={center.email}
          toggle={toggleModal}
          title={center.title}
          trackingID={'Profile Intro'}
          location={center.location_label}
          image={center.slides[0]}
          setModal={setModal}
          benefitsKey={center?.benefitsKey}
          benefitsProvider={center?.benefitsProvider}
          insuranceAccepted={
            !!(
              center?.amenities?.includes('Insurance Accepted') ||
              center.price?.includes('Insurance Accepted')
            )
          }
          breadcrumbs={breadcrumbs}
        />
      )}
      <Style ref={ref}>
        <div className="flex w-full flex-col justify-between pt-4 md:mx-8 md:flex-row md:pt-16 xl:mx-0">
          <div className="flex flex-col md:pr-20">
            <div className="flex max-w-[600px] flex-col gap-6 pb-2">
              <div className="flex flex-col gap-2">
                <h3 className="text-lg font-medium text-gray-800">
                  {center.location_label}
                </h3>
                <div className="items-center justify-start">
                  <h1
                    id="profile-intro-center-name"
                    className="mb-2 mr-2 inline text-4xl font-medium text-gray-1100"
                  >
                    {center.title}
                  </h1>
                  <CenterStatusBadge center={center} />
                </div>
              </div>
              <CenterBadgesAndRatingSection
                center={center}
                pageType={pageType}
                allReviewsCount={allReviewsCount}
                allReviewsWeightedAverage={allReviewsWeightedAverage}
              />
              {showSubmitPrice && (
                <div className="text-sm text-gray-800">
                  Do you know the price?
                  <a
                    className="ml-1 font-semibold text-gray-1100 underline underline-offset-2"
                    target="_blank"
                    href="https://rehabpath.typeform.com/to/usxiWw34"
                  >
                    Submit it
                  </a>
                </div>
              )}
              <div className="text-base text-gray-800">
                {center.short_description}
              </div>
            </div>
            {shouldShowCenterHighlights(center) && (
              <div className="mt-6 flex flex-col gap-4 py-2">
                <div className="flex items-center gap-1">
                  <h3 className="text-xl font-semibold text-gray-1100">
                    Highlights from the Center
                  </h3>
                  <div className="mt-1">
                    <Tooltip
                      triggerImage={unclaimedIcon}
                      unclaimedCenter
                      tooltipTitle={'Highlights'}
                      tooltipBodyText={
                        'These highlights are provided by and paid for by the center. For more information <a class="underline" href="/contact/">Contact Us</a>.'
                      }
                      footerLink={'/contact/'}
                    />
                  </div>
                </div>
                <ul className="space-y-[10px]">
                  {center.highlights &&
                    getHighlightsWithIcons(center.highlights).map(
                      (highlight) => {
                        if (highlight.icon == null) {
                          return null
                        }
                        return (
                          <li
                            key={highlight.label}
                            className="flex items-center gap-2"
                          >
                            <img
                              className="highlight-icon size-9"
                              src={highlight.icon}
                              alt=""
                            />
                            <p>{highlight.label}</p>
                          </li>
                        )
                      }
                    )}
                </ul>
              </div>
            )}
          </div>
          <div className="max-w-[436px]">
            {isNonEmptyArray(center.slides) && (
              <NavMarkers id="profile-photo">
                <div className="mobile">
                  <SliderColumn template={'Premium'}>
                    <Sliders {...sliderProps} />
                    <div />
                  </SliderColumn>
                </div>
              </NavMarkers>
            )}
            <div id="contact-box">
              {!center.claimed_email ? (
                <div>
                  <div
                    className="contact-box"
                    style={{ borderRadius: '16px' }}
                  >
                    <div className="relative">
                      <div className="absolute -bottom-[30px] -right-[14px] z-[100]">
                        <FavoriteCenterHeartButtonContactBlock
                          isFavorite={isFavorite(
                            parseCenterId({ pageType, center })
                          )}
                          centerId={parseCenterId({ pageType, center })}
                          centerSlug={center.slug}
                        />
                      </div>
                    </div>
                    {isNonEmptyString(centerLogo) && (
                      <img
                        className="logo mx-auto mb-6 w-[153px]"
                        src={centerLogo}
                      />
                    )}
                    {(hasWebsite(center) ||
                      isNonEmptyArray(center.phone_numbers)) && (
                      <>
                        <div className="relative mb-1">
                          <h3 className="mb-1 text-xl font-medium text-gray-1100">
                            Contact {center.title}
                          </h3>
                          <p className="text-gray-700">
                            Connect with {center.title} by calling them
                            directly.
                          </p>
                        </div>
                        <div className="mb-6 flex flex-col">
                          <div
                            className={
                              center.primary_cta === 'call' ||
                              center.primary_cta === null
                                ? 'order-1'
                                : 'order-2'
                            }
                          >
                            {isNonEmptyArray(center.phone_numbers) &&
                              center.phone_numbers.map(
                                ({ label, number }, index) => (
                                  <a
                                    className={`${CONTACT_CLASSNAME} ${
                                      (center.primary_cta === 'call' ||
                                        center.primary_cta === null) &&
                                      index === 0
                                        ? 'bg-primary-800 !text-gray-50'
                                        : ''
                                    }`}
                                    onClick={() => {
                                      handleDataLayerPhoneNumberClick({
                                        center,
                                        number,
                                        label
                                      })
                                    }}
                                    href={`tel:${removeWhiteSpaces(number)}`}
                                    key={number}
                                  >
                                    <div className="flex">
                                      <img
                                        src={
                                          (center.primary_cta === 'call' ||
                                            center.primary_cta === null) &&
                                          index === 0
                                            ? iconPhoneWhite
                                            : phonePurple
                                        }
                                        className="mr-3 w-4"
                                      />
                                      <div>
                                        <p className="leading-5">{number}</p>
                                        <p className="text-left text-xs">
                                          {label}
                                        </p>
                                      </div>
                                    </div>
                                    <div
                                      className={
                                        (center.primary_cta === 'call' ||
                                          center.primary_cta === null) &&
                                        index === 0
                                          ? 'text-gray-50'
                                          : 'text-primary-800'
                                      }
                                    >
                                      <ChevronRight />
                                    </div>
                                  </a>
                                )
                              )}
                          </div>
                          {hasWebsite(center) && (
                            <div
                              className={
                                center.primary_cta === 'email' ||
                                center.primary_cta === 'message'
                                  ? 'order-1'
                                  : 'order-2'
                              }
                            >
                              <a
                                className={`${CONTACT_CLASSNAME} ${
                                  center.primary_cta === 'email' ||
                                  center.primary_cta === 'message'
                                    ? 'bg-primary-800 !text-gray-50'
                                    : ''
                                }`}
                                target="_blank"
                                href={getWebsite(center)}
                                rel="noreferrer"
                                onClick={() => {
                                  recordAlgoliaConversion({
                                    userID,
                                    event: 'ProfileWebsite',
                                    queryID: queryID,
                                    objectID: center.slug
                                  })
                                  handleDataLayerWebsiteClick(center)
                                }}
                              >
                                <div className="flex">
                                  <img
                                    src={
                                      center.primary_cta === 'email' ||
                                      center.primary_cta === 'message'
                                        ? iconWebGray
                                        : iconWeb
                                    }
                                    className="mr-3 w-4"
                                  />
                                  <p> Website</p>
                                </div>

                                <div
                                  className={
                                    center.primary_cta === 'email' ||
                                    center.primary_cta === 'message'
                                      ? 'text-gray-50'
                                      : 'text-primary-800'
                                  }
                                >
                                  <ChevronRight />
                                </div>
                              </a>
                            </div>
                          )}
                        </div>
                      </>
                    )}

                    <p className="text-gray-700">
                      Are you the owner of this center?
                      <br />
                      <a
                        className="font-semibold underline"
                        href="https://providers.recovery.com"
                      >
                        Claim this center
                      </a>
                    </p>
                  </div>
                </div>
              ) : (
                <div className="message-box">
                  {center.claimed_email &&
                    (center.primary_cta === 'email' ||
                    center.primary_cta === 'message' ? (
                      <React.Fragment>
                        <div>
                          <div className="relative">
                            <div className="absolute -bottom-[20px] -right-[24px] z-[100]">
                              <FavoriteCenterHeartButtonContactBlock
                                isFavorite={isFavorite(
                                  parseCenterId({ pageType, center })
                                )}
                                centerId={parseCenterId({ pageType, center })}
                                centerSlug={center.slug}
                              />
                            </div>
                          </div>
                          {center.logo ? (
                            <div>
                              <img
                                className="logo"
                                src={center.logo}
                                style={{
                                  width: '153px',
                                  margin: '0 auto 24px'
                                }}
                              />
                            </div>
                          ) : (
                            ''
                          )}
                          <div className="mb-6">
                            <h5 className="mb-1 text-xl font-medium text-gray-1100">
                              Message {center.title}
                            </h5>
                            <p className="text-gray-700">
                              Connect with {center.title} by messaging their
                              admissions team directly.
                            </p>
                          </div>

                          <div className="mt-6">
                            <Button
                              onClick={() => {
                                handleDataLayerInquiryClick(center)
                                toggleModal()
                              }}
                              fluid
                              color="purple"
                              flex
                              style={{ height: '56px' }}
                            >
                              <a className="flex size-full items-center justify-between px-4 py-[10px] text-lg font-normal text-white no-underline">
                                <div className="flex">
                                  <img
                                    src={whiteEnvelope}
                                    className="mr-3 w-4"
                                  />

                                  <p>Message Center</p>
                                </div>
                                <ChevronRight />
                              </a>
                            </Button>
                          </div>
                          <div className="mt-4">
                            <div className="flex items-center">
                              <span className="h-px w-1/2 bg-gray-300"></span>
                              <span className="mx-2 text-base font-medium text-gray-700">
                                OR
                              </span>
                              <span className="h-px w-1/2 bg-gray-300"></span>
                            </div>
                          </div>
                          <div className="mt-4">
                            <div>
                              <React.Fragment>
                                {center.phone_numbers.map(
                                  ({ number, label }) => (
                                    <>
                                      {shouldUseWhatsappText(label) ? (
                                        <>
                                          <Button
                                            style={{
                                              backgroundColor: '#EBEAF4',
                                              height: '56px',
                                              marginTop: '16px',
                                              alignItems: 'center',
                                              display: 'flex',
                                              justifyContent: 'center'
                                            }}
                                            fluid
                                            flex
                                            bold
                                            large
                                          >
                                            <a
                                              className="flex size-full items-center justify-between px-4 py-[10px] text-lg font-normal text-primary-800 no-underline"
                                              href={`https://wa.me/${number
                                                .replace(/[^\w\s]/gi, '')
                                                .replace(
                                                  / /g,
                                                  ''
                                                )}?text=${encodeURI(
                                                "I'm contacting you from Recovery.com in search of treatment. Can you provide more information on your admissions process?"
                                              )}`}
                                              onClick={() => {
                                                analytics.ui.callCta({
                                                  number,
                                                  label,
                                                  center_slug:
                                                    getCenterProfileSlug(center)
                                                })
                                              }}
                                            >
                                              <div className="flex">
                                                <img
                                                  src={phonePurple}
                                                  className="mr-3 w-4"
                                                />

                                                <div>
                                                  <p>{number}</p>
                                                  <p className="text-left text-xs">
                                                    {label}
                                                  </p>
                                                </div>
                                              </div>
                                              <div className="text-primary-800">
                                                <ChevronRight />
                                              </div>
                                            </a>
                                            <br />
                                          </Button>
                                        </>
                                      ) : (
                                        <Button
                                          style={{
                                            backgroundColor: '#EBEAF4',
                                            height: '56px',
                                            marginTop: '16px'
                                          }}
                                          fluid
                                          flex
                                          bold
                                          large
                                        >
                                          <a
                                            className="flex size-full items-center justify-between px-4 py-[10px] text-lg font-normal text-primary-800 no-underline"
                                            onClick={() => {
                                              handleDataLayerPhoneNumberClick({
                                                center,
                                                number,
                                                label
                                              })
                                            }}
                                            href={`tel:${removeWhiteSpaces(
                                              number
                                            )}`}
                                          >
                                            <div className="flex">
                                              <img
                                                src={phonePurple}
                                                className="mr-3 w-4"
                                              />
                                              <div>
                                                <p>{number}</p>
                                                <p className="text-left text-xs">
                                                  {label}
                                                </p>
                                              </div>
                                            </div>
                                            <div className="text-primary-800">
                                              <ChevronRight />
                                            </div>
                                          </a>
                                          <br />
                                        </Button>
                                      )}
                                    </>
                                  )
                                )}
                              </React.Fragment>
                            </div>
                            <div className="mt-4">
                              <a
                                className="text-primary-800 no-underline"
                                target="_blank"
                                href={center.website}
                                rel="noreferrer"
                              >
                                <Button
                                  style={{
                                    backgroundColor: '#EBEAF4',
                                    height: '52px'
                                  }}
                                  onClick={() => {
                                    recordAlgoliaConversion({
                                      userID,
                                      event: 'ProfileWebsite',
                                      queryID: queryID,
                                      objectID: center.slug
                                    })
                                    handleDataLayerWebsiteClick(center)
                                    analytics.profilePage.outboundWebsiteLink({
                                      website: center.website
                                    })
                                  }}
                                  fluid
                                  flex
                                >
                                  <div className="flex size-full items-center justify-between px-4 py-[10px] text-lg font-normal text-primary-800 no-underline">
                                    <div className="flex ">
                                      <img
                                        src={iconWeb}
                                        className="mr-3 w-4"
                                      />
                                      <p>Website</p>
                                    </div>
                                    <div className="text-primary-800">
                                      <ChevronRight />
                                    </div>
                                  </div>
                                </Button>
                              </a>
                            </div>
                          </div>
                        </div>
                      </React.Fragment>
                    ) : (
                      (center.primary_cta === 'call' ||
                        center.primary_cta === null) && (
                        <React.Fragment>
                          {center.logo ? (
                            <div>
                              <div className="relative">
                                <div className="absolute -bottom-[20px] -right-[24px] z-[100]">
                                  <FavoriteCenterHeartButtonContactBlock
                                    isFavorite={isFavorite(
                                      parseCenterId({ pageType, center })
                                    )}
                                    centerId={parseCenterId({
                                      pageType,
                                      center
                                    })}
                                    centerSlug={center.slug}
                                  />
                                </div>
                              </div>
                              <img
                                className="logo"
                                src={center.logo}
                                style={{
                                  width: '153px',
                                  margin: '0 auto 24px'
                                }}
                              />
                            </div>
                          ) : (
                            <div className="relative">
                              <div className="absolute -bottom-[20px] -right-[24px]">
                                <FavoriteCenterHeartButtonContactBlock
                                  isFavorite={isFavorite(
                                    parseCenterId({ pageType, center })
                                  )}
                                  centerId={parseCenterId({ pageType, center })}
                                  centerSlug={center.slug}
                                />
                              </div>
                            </div>
                          )}
                          <div className="mb-6">
                            <h5 className="mb-1 text-xl font-medium text-gray-1100">
                              Call {center.title}
                            </h5>
                            <p className="text-gray-700">
                              Connect with {center.title} by calling their
                              admissions team directly.
                            </p>
                          </div>

                          {getPhoneNumbers(center)[0] && (
                            <div>
                              <React.Fragment>
                                <Button
                                  style={{
                                    height: '56px',
                                    fontSize: '18px',
                                    fontWeight: 400,
                                    alignItems: 'center',
                                    display: 'flex',
                                    justifyContent: 'center'
                                  }}
                                  color="purple"
                                >
                                  {shouldUseWhatsappText(
                                    center.phone_numbers[0]?.label
                                  ) ? (
                                    <>
                                      <a
                                        id="phone-number-click"
                                        className="flex size-full items-center justify-between px-4 py-[10px] text-lg font-normal text-white no-underline"
                                        href={`https://wa.me/${center.phone_numbers[0].number
                                          .replace(/[^\w\s]/gi, '')
                                          .replace(/ /g, '')}?text=${encodeURI(
                                          "I'm contacting you from Recovery.com in search of treatment. Can you provide more information on your admissions process?"
                                        )}`}
                                        onClick={() => {
                                          analytics.ui.callCta({
                                            ...getPhoneNumbers(center)[0],
                                            center_slug:
                                              getCenterProfileSlug(center)
                                          })
                                        }}
                                      >
                                        <div className="flex">
                                          <img
                                            src={iconPhoneWhite}
                                            className="mr-3 w-4"
                                          />
                                          <div>
                                            <p>
                                              {center.phone_numbers[0].number}
                                            </p>
                                            <p className="text-left text-xs">
                                              {center.phone_numbers[0].label}
                                            </p>
                                          </div>
                                        </div>
                                        <div>
                                          <ChevronRight />
                                        </div>
                                      </a>
                                    </>
                                  ) : (
                                    <a
                                      id="phone-number-click"
                                      className="flex size-full items-center justify-between px-4 py-[10px] text-lg font-normal text-white no-underline"
                                      onClick={() => {
                                        handleDataLayerPhoneNumberClick({
                                          center,
                                          ...getPhoneNumbers(center)[0]
                                        })
                                      }}
                                      href={`tel:${removeWhiteSpaces(
                                        getPhoneNumbers(center)[0]?.number
                                      )}`}
                                    >
                                      <div className="flex">
                                        <img
                                          src={iconPhoneWhite}
                                          className="mr-3 w-4"
                                        />
                                        <div>
                                          <p>
                                            {getPhoneNumbers(center)[0]?.number}
                                          </p>
                                          <p className="text-left text-xs">
                                            {getPhoneNumbers(center)[0]?.label}
                                          </p>
                                        </div>
                                      </div>
                                      <div>
                                        <ChevronRight />
                                      </div>
                                    </a>
                                  )}
                                  <br />
                                </Button>
                              </React.Fragment>
                            </div>
                          )}
                          <div>
                            <div className="mt-4">
                              <div className="flex items-center">
                                <span className="h-px w-1/2 bg-gray-300"></span>
                                <span className="mx-2 text-base font-medium text-gray-700">
                                  OR
                                </span>
                                <span className="h-px w-1/2 bg-gray-300"></span>
                              </div>
                            </div>
                            <div className="mt-4">
                              <React.Fragment>
                                {center.phone_numbers
                                  .slice(1)
                                  .map(({ number, label }) => {
                                    return (
                                      <Button
                                        style={{
                                          marginTop: '16px',
                                          height: '52px',
                                          backgroundColor: '#EBEAF4'
                                        }}
                                        color="purple"
                                        key={number}
                                      >
                                        {shouldUseWhatsappText(label) ? (
                                          <>
                                            <a
                                              id="phone-number-click"
                                              className="flex size-full items-center justify-between px-4 py-[10px] text-lg font-normal text-primary-800 no-underline"
                                              href={`https://wa.me/${number
                                                .replace(/[^\w\s]/gi, '')
                                                .replace(
                                                  / /g,
                                                  ''
                                                )}?text=${encodeURI(
                                                "I'm contacting you from Recovery.com in search of treatment. Can you provide more information on your admissions process?"
                                              )}`}
                                              onClick={() => {
                                                analytics.ui.callCta({
                                                  number,
                                                  label,
                                                  center_slug:
                                                    getCenterProfileSlug(center)
                                                })
                                              }}
                                            >
                                              <div className="flex text-left text-primary-800">
                                                <img
                                                  src={phonePurple}
                                                  className="mr-3 w-4"
                                                />
                                                <div className="text-left text-primary-800">
                                                  <p>{number}</p>
                                                  <p className="text-left text-xs">
                                                    {label}
                                                  </p>
                                                </div>
                                              </div>
                                              <div className="text-primary-800">
                                                <ChevronRight />
                                              </div>
                                            </a>
                                          </>
                                        ) : (
                                          <a
                                            id="phone-number-click"
                                            className="flex size-full items-center justify-between px-4 py-[10px] text-lg font-normal text-primary-800 no-underline"
                                            onClick={() => {
                                              handleDataLayerPhoneNumberClick({
                                                center,
                                                href: `tel:${removeWhiteSpaces(
                                                  number
                                                )}`
                                              })
                                            }}
                                            href={`tel:${removeWhiteSpaces(
                                              number
                                            )}`}
                                          >
                                            <div className="flex text-left text-primary-800">
                                              <img
                                                src={phonePurple}
                                                className="mr-2"
                                              />
                                              <div className="text-left text-primary-800">
                                                <p>{number}</p>
                                                <p className="text-left text-xs">
                                                  {label}
                                                </p>
                                              </div>
                                            </div>
                                            <div className="text-primary-800">
                                              <ChevronRight />
                                            </div>
                                          </a>
                                        )}
                                        <br />
                                      </Button>
                                    )
                                  })}
                              </React.Fragment>
                            </div>
                            <div className="mt-4">
                              <Button
                                className="mt-4 h-14 !bg-[#EBEAF4]"
                                onClick={() => {
                                  handleDataLayerInquiryClick(center)
                                  toggleModal()
                                }}
                                fluid
                                flex
                              >
                                <a className="flex size-full items-center justify-between px-4 py-[10px] text-lg font-normal text-primary-800 no-underline">
                                  <div className="mr-4 flex">
                                    <img
                                      src={iconEnvelopePurple}
                                      className="mr-3 w-4"
                                    />
                                    <p>Message Center</p>
                                  </div>
                                  <div className="text-primary-800">
                                    <ChevronRight />
                                  </div>
                                </a>
                              </Button>
                            </div>
                            <div className="mt-4">
                              <a
                                className="text-primary-800 no-underline"
                                target="_blank"
                                href={center.website}
                                rel="noreferrer"
                              >
                                <Button
                                  className="h-[52px] !bg-[#EBEAF4]"
                                  onClick={() => {
                                    recordAlgoliaConversion({
                                      userID,
                                      event: 'ProfileWebsite',
                                      queryID: queryID,
                                      objectID: center.slug
                                    })
                                    handleDataLayerWebsiteClick(center)
                                    analytics.profilePage.outboundWebsiteLink({
                                      website: center.website
                                    })
                                  }}
                                  fluid
                                  flex
                                >
                                  <div className="flex size-full items-center justify-between px-4 py-[10px] text-lg font-normal text-primary-800 no-underline">
                                    <div className="flex">
                                      <img
                                        src={iconWeb}
                                        className="mr-3 w-4"
                                      />
                                      <p>Website</p>
                                    </div>
                                    <div className="text-primary-800">
                                      <ChevronRight />
                                    </div>
                                  </div>
                                </Button>
                              </a>
                            </div>
                          </div>
                        </React.Fragment>
                      )
                    ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </Style>
      {isNonEmptyArray(center.slides) && (
        <NavMarkers id="profile-photos">
          <Desktop>
            <SliderColumn template={'Premium'}>
              <Sliders {...sliderProps} />
              <div />
            </SliderColumn>
          </Desktop>
        </NavMarkers>
      )}
    </React.Fragment>
  )
})

export default ProfileIntro
